<mat-form-field class="selection-field">
  <mat-select
    [disabled]="disabled"
    (selectionChange)="onSelectionChanged($event)"
    [value]="cellParameters.value"
  >
    @for (option of selectionOptions; track option) {
      <mat-option [title]="option.display" [value]="option.value">{{
        option.display
      }}</mat-option>
    }
  </mat-select>
</mat-form-field>
